import React from 'react';

import TextField from '@mui/material/TextField';
import { Grid, MenuItem, Select } from '@mui/material';

import dayjs from 'dayjs';
import { datetimeLocalToIso, isoToDatetimeLocal } from '../../../../utils/Date';

const DEFAULT_DATETIME_FORMAT = 'yyyy-MM-DD hh:MM:ssZ';

function DatetimeInput({ pH, values, setValues, updateValueInValues }) {
  const value = values?.[pH?.key]?.value;
  const rawDatetimeValue = value?.rawValue ? isoToDatetimeLocal(value.rawValue) : '';

  const handleDateTimeChange = newDatetimeValue => {
    if (!newDatetimeValue) return;

    const isoString = datetimeLocalToIso(newDatetimeValue);
    const dayjsDate = dayjs(isoString);

    if (!dayjsDate.isValid()) return;

    const dateTimeFormat = value?.format || DEFAULT_DATETIME_FORMAT;
    const newValue = {
      rawValue: isoString,
      format: dateTimeFormat,
      value: dayjsDate.format(dateTimeFormat),
    };

    updateValueInValues(pH.key, newValue);
  };

  return (
    <Grid container rowGap={1}>
      <Grid item xs={12}>
        <TextField
          type="datetime-local"
          value={rawDatetimeValue}
          onChange={e => handleDateTimeChange(e.target.value)}
          size="small"
          fullWidth
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Select
          onChange={e => {
            const newValue = {
              rawValue: value?.rawValue,
              format: e.target.value,
              value: value?.value,
            };
            updateValueInValues(pH.key, newValue);
          }}
          className={'date-format-select'}
          variant={'outlined'}
          value={value?.format}
          defaultValue={DEFAULT_DATETIME_FORMAT}
          size="small"
          fullWidth
        >
          <MenuItem value={'yyyy-MM-DD hh:MM:ssZ'}>yyyy-MM-DD hh:MM:ssZ</MenuItem>
          <MenuItem value={'dd LLLL YYYY'}>dd Month yyyy [01 February 2021]</MenuItem>
          <MenuItem value={'dd LLLL YYYY kk:mm'}>
            dd Month yyyy hh:mm [01 February 2021 14:01]
          </MenuItem>
          <MenuItem value={'dd/MM/YY'}>dd/mm/yy [01/02/21]</MenuItem>
          <MenuItem value={'dd/MM/YY kk:mm'}>dd/mm/yy hh:mm [01/02/21 14:01]</MenuItem>
          <MenuItem value={'dd/MM/YYYY'}>dd/mm/yyyy [01/02/2021]</MenuItem>
          <MenuItem value={'dd/MM/YYYY kk:mm'}>dd/mm/yyyy hh:mm [01/02/2021 14:01]</MenuItem>
          <MenuItem value={'dd-MM-YYYY'}>dd-mm-yyyy [01-02-2021]</MenuItem>
          <MenuItem value={'dd-MM-YYYY kk:mm'}>dd-mm-yyyy hh:mm [01-02-2021 14:01]</MenuItem>
          <MenuItem value={'MM/dd/YYYY'}>mm/dd/yyyy [02/01/2021]</MenuItem>
          <MenuItem value={'MM/dd/YYYY kk:mm'}>mm/dd/yyyy hh:mm [02/01/2021 14:01]</MenuItem>
          <MenuItem value={'YYYY-MM-dd'}>yyyy-mm-dd [2021-02-01]</MenuItem>
          <MenuItem value={'YYYY-MM-dd kk:mm'}>yyyy-mm-dd hh:mm [2021-02-01 14:01]</MenuItem>
          <MenuItem value={'Unix'}>Unix [1612148400]</MenuItem>
        </Select>
      </Grid>
    </Grid>
  );
}

export default DatetimeInput;
